import TypeOfRadiobox from './TypeOfRadiobox';

export default TypeOfRadiobox;